"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ecom = void 0;
var Agent_1 = require("./agent/implementation/Agent");
var productValidationService_1 = require("./sections/products/services/productValidationService");
var GetProductBySlugUseCase_1 = require("./sections/products/useCases/getProductBySlug/GetProductBySlugUseCase");
var GetProductsByCategoryUseCase_1 = require("./sections/products/useCases/getProductsByCategory/GetProductsByCategoryUseCase");
var GetContentMenusUseCase_1 = require("./sections/content/useCases/getContentMenus/GetContentMenusUseCase");
var GetContentHomeUseCase_1 = require("./sections/content/useCases/getContentHome/GetContentHomeUseCase");
var GetContentPageUseCase_1 = require("./sections/content/useCases/getContentPage/GetContentPageUseCase");
var GetContentPageByIdUseCase_1 = require("./sections/content/useCases/GetContentPageByIdUseCase/GetContentPageByIdUseCase");
var contentValidationService_1 = require("./sections/content/services/contentValidationService");
var GetCartItemsUseCase_1 = require("./sections/cart/useCases/getCartItems/GetCartItemsUseCase");
var AddItemToCartUseCase_1 = require("./sections/cart/useCases/addItemToCart/AddItemToCartUseCase");
var RemoveItemFromCartUseCase_1 = require("./sections/cart/useCases/removeItemFromCart/RemoveItemFromCartUseCase");
var ClearCartUseCase_1 = require("./sections/cart/useCases/clearCart/ClearCartUseCase");
var UpdateCartItemUseCase_1 = require("./sections/cart/useCases/updateCartItem/UpdateCartItemUseCase");
var cartValidationService_1 = require("./sections/cart/services/cartValidationService");
var GetUserUseCase_1 = require("./sections/users/useCases/getUser/GetUserUseCase");
var userValidationService_1 = require("./sections/users/services/userValidationService");
var RequestPasswordUseCase_1 = require("./sections/users/useCases/requestPassword/RequestPasswordUseCase");
var SignInUseCase_1 = require("./sections/users/useCases/signIn/SignInUseCase");
var SignUpUseCase_1 = require("./sections/users/useCases/signUp/SignUpUseCase");
var UpdateUserUseCase_1 = require("./sections/users/useCases/updateUser/UpdateUserUseCase");
var GetWishlistItemsUseCase_1 = require("./sections/wishlist/useCases/getWishlistItems/GetWishlistItemsUseCase");
var AddItemToWishlistUseCase_1 = require("./sections/wishlist/useCases/addItemToWishlist/AddItemToWishlistUseCase");
var RemoveItemFromWishlistUseCase_1 = require("./sections/wishlist/useCases/removeItemFromWishlist/RemoveItemFromWishlistUseCase");
var ClearWishlistUseCase_1 = require("./sections/wishlist/useCases/clearWishlist/ClearWishlistUseCase");
var wishlistValidationService_1 = require("./sections/wishlist/services/wishlistValidationService");
var GetRelatedProductsUseCase_1 = require("./sections/products/useCases/getRelatedProducts/GetRelatedProductsUseCase");
var GetSameProductsUseCase_1 = require("./sections/products/useCases/getSameProducts/GetSameProductsUseCase");
var GetConfigsUseCase_1 = require("./sections/configs/useCases/getConfigs/GetConfigsUseCase");
var configsValidationService_1 = require("./sections/configs/services/configsValidationService");
var GetRecentlyProductsUseCase_1 = require("./sections/products/useCases/getRecentlyProducts/GetRecentlyProductsUseCase");
var GetPromotionsUseCase_1 = require("./sections/promotions/useCases/getPromotions/GetPromotionsUseCase");
var promotionValidationService_1 = require("./sections/promotions/services/promotionValidationService");
var GetPromotionBySlugUseCase_1 = require("./sections/promotions/useCases/getPromotionBySlug/GetPromotionBySlugUseCase");
var GetProductsByPromotionUseCase_1 = require("./sections/products/useCases/getProductsByPromotion/GetProductsByPromotionUseCase");
var categoryValidationService_1 = require("./sections/categories/services/categoryValidationService");
var GetCategoriesUseCase_1 = require("./sections/categories/useCases/getCategoriesUseCase/GetCategoriesUseCase");
var GetFiltersByCategorySlugUseCase_1 = require("./sections/filters/useCases/getFiltersByCategorySlug/GetFiltersByCategorySlugUseCase");
var filterValidationService_1 = require("./sections/filters/services/filterValidationService");
var GetAvailableFilterVariantsByCategoryUseCase_1 = require("./sections/filters/useCases/getAvailableFilterVariantsByCategory/GetAvailableFilterVariantsByCategoryUseCase");
var GetFiltersByPromotionSlugUseCase_1 = require("./sections/filters/useCases/getFiltersByPromotionSlug/GetFiltersByPromotionSlugUseCase");
var GetAvailableFilterVariantsByPromotionUseCase_1 = require("./sections/filters/useCases/getAvailableFilterVariantsByPromotion/GetAvailableFilterVariantsByPromotionUseCase");
var GetBrandsUseCase_1 = require("./sections/brands/useCases/getBrands/GetBrandsUseCase");
var brandValidationService_1 = require("./sections/brands/services/brandValidationService");
var GetBrandBySlugUseCase_1 = require("./sections/brands/useCases/getBrandBySlug/GetBrandBySlugUseCase");
var GetAvailableFilterVariantsByBrandUseCase_1 = require("./sections/filters/useCases/getAvailableFilterVariantsByBrand/GetAvailableFilterVariantsByBrandUseCase");
var GetProductsByBrandUseCase_1 = require("./sections/products/useCases/getProductsByBrand/GetProductsByBrandUseCase");
var GetFiltersByBrandSlugUseCase_1 = require("./sections/filters/useCases/getFiltersByBrandSlug/GetFiltersByBrandSlugUseCase");
var GetSetsUseCase_1 = require("./sections/sets/useCases/getSets/GetSetsUseCase");
var setValidationService_1 = require("./sections/sets/services/setValidationService");
var GetSetBySlugUseCase_1 = require("./sections/sets/useCases/getSetBySlug/GetSetBySlugUseCase");
var GetProductsBySetUseCase_1 = require("./sections/products/useCases/getProductsBySet/GetProductsBySetUseCase");
var GetFiltersBySetSlugUseCase_1 = require("./sections/filters/useCases/getFiltersBySetSlug/GetFiltersBySetSlugUseCase");
// PS. Need to revisit this class
var Ecom = /** @class */ (function () {
    function Ecom(configProps) {
        this.authToken = '';
        this.sessionToken = '';
        this.userLocale = '';
        this.forwardedHost = '';
        this.forwardedFor = '';
        this.origin = '';
        this.cancelToken = '';
        this.configProps = configProps;
        this.agent = this.configureAgent(this.getConfigPropsm(), configProps.headers || {});
    }
    Object.defineProperty(Ecom.prototype, "transport", {
        get: function () {
            return this.agent.transport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "product", {
        get: function () {
            return {
                getProductBySlug: new GetProductBySlugUseCase_1.GetProductBySlugUseCase(this.agent, productValidationService_1.productValidationService),
                getProductsByCategory: new GetProductsByCategoryUseCase_1.GetProductsByCategoryUseCase(this.agent, productValidationService_1.productValidationService),
                getProductsByPromotion: new GetProductsByPromotionUseCase_1.GetProductsByPromotionUseCase(this.agent, productValidationService_1.productValidationService),
                getProductsByBrand: new GetProductsByBrandUseCase_1.GetProductsByBrandUseCase(this.agent, productValidationService_1.productValidationService),
                getProductsBySet: new GetProductsBySetUseCase_1.GetProductsBySetUseCase(this.agent, productValidationService_1.productValidationService),
                getRelatedProducts: new GetRelatedProductsUseCase_1.GetRelatedProductsUseCase(this.agent, productValidationService_1.productValidationService),
                getSameProducts: new GetSameProductsUseCase_1.GetSameProductsUseCase(this.agent, productValidationService_1.productValidationService),
                getRecentlyProducts: new GetRecentlyProductsUseCase_1.GetRecentlyProductsUseCase(this.agent, productValidationService_1.productValidationService),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "category", {
        get: function () {
            return {
                getCategories: new GetCategoriesUseCase_1.GetCategoriesUseCase(this.agent, categoryValidationService_1.categoryValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "filter", {
        get: function () {
            return {
                getFiltersByCategorySlug: new GetFiltersByCategorySlugUseCase_1.GetFiltersByCategorySlugUseCase(this.agent, filterValidationService_1.filterValidationService),
                getFiltersByPromotionSlug: new GetFiltersByPromotionSlugUseCase_1.GetFiltersByPromotionSlugUseCase(this.agent, filterValidationService_1.filterValidationService),
                getFiltersByBrandSlug: new GetFiltersByBrandSlugUseCase_1.GetFiltersByBrandSlugUseCase(this.agent, filterValidationService_1.filterValidationService),
                getFiltersBySetSlug: new GetFiltersBySetSlugUseCase_1.GetFiltersBySetSlugUseCase(this.agent, filterValidationService_1.filterValidationService),
                getAvailableFilterVariantsByCategory: new GetAvailableFilterVariantsByCategoryUseCase_1.GetAvailableFilterVariantsByCategoryUseCase(this.agent, filterValidationService_1.filterValidationService),
                getAvailableFilterVariantsByPromotion: new GetAvailableFilterVariantsByPromotionUseCase_1.GetAvailableFilterVariantsByPromotionUseCase(this.agent, filterValidationService_1.filterValidationService),
                getAvailableFilterVariantsByBrand: new GetAvailableFilterVariantsByBrandUseCase_1.GetAvailableFilterVariantsByBrandUseCase(this.agent, filterValidationService_1.filterValidationService),
                /**
                 * @deprecated Use getAvailableFilterVariantsByCategory() instead
                 */
                getAvailableFilterVariants: new GetAvailableFilterVariantsByCategoryUseCase_1.GetAvailableFilterVariantsByCategoryUseCase(this.agent, filterValidationService_1.filterValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "content", {
        get: function () {
            return {
                getContentMenus: new GetContentMenusUseCase_1.GetContentMenusUseCase(this.agent, contentValidationService_1.contentValidationService),
                getContentHome: new GetContentHomeUseCase_1.GetContentHomeUseCase(this.agent, contentValidationService_1.contentValidationService),
                getContentPage: new GetContentPageUseCase_1.GetContentPageUseCase(this.agent, contentValidationService_1.contentValidationService),
                getContentPageById: new GetContentPageByIdUseCase_1.GetContentPageByIdUseCase(this.agent, contentValidationService_1.contentValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "cart", {
        get: function () {
            return {
                getCartItems: new GetCartItemsUseCase_1.GetCartItemsUseCase(this.agent, cartValidationService_1.cartValidationService),
                addItemToCart: new AddItemToCartUseCase_1.AddItemToCartUseCase(this.agent, cartValidationService_1.cartValidationService),
                removeItemFromCart: new RemoveItemFromCartUseCase_1.RemoveItemFromCartUseCase(this.agent, cartValidationService_1.cartValidationService),
                clearCart: new ClearCartUseCase_1.ClearCartUseCase(this.agent, cartValidationService_1.cartValidationService),
                updateCartItem: new UpdateCartItemUseCase_1.UpdateCartItemUseCase(this.agent, cartValidationService_1.cartValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "user", {
        get: function () {
            return {
                getUser: new GetUserUseCase_1.GetUserUseCase(this.agent, userValidationService_1.userValidationService),
                requestPassword: new RequestPasswordUseCase_1.RequestPasswordUseCase(this.agent, userValidationService_1.userValidationService),
                signIn: new SignInUseCase_1.SignInUseCase(this.agent, userValidationService_1.userValidationService),
                signUp: new SignUpUseCase_1.SignUpUseCase(this.agent, userValidationService_1.userValidationService),
                updateUser: new UpdateUserUseCase_1.UpdateUserUseCase(this.agent, userValidationService_1.userValidationService),
                setUserAvatar: new UpdateUserUseCase_1.UpdateUserUseCase(this.agent, userValidationService_1.userValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "wishlist", {
        get: function () {
            return {
                getWishlist: new GetWishlistItemsUseCase_1.GetWishlistItemsUseCase(this.agent, wishlistValidationService_1.whishlistValidationService),
                addWishlistItem: new AddItemToWishlistUseCase_1.AddItemToWishlistUseCase(this.agent, wishlistValidationService_1.whishlistValidationService),
                removeWishlistItem: new RemoveItemFromWishlistUseCase_1.RemoveItemFromWishlistUseCase(this.agent, wishlistValidationService_1.whishlistValidationService),
                clearWishlist: new ClearWishlistUseCase_1.ClearWishlistUseCase(this.agent, wishlistValidationService_1.whishlistValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "configs", {
        get: function () {
            return {
                getConfigs: new GetConfigsUseCase_1.GetConfigsUseCase(this.agent, configsValidationService_1.configsValidationService),
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "promotion", {
        get: function () {
            return {
                getPromotions: new GetPromotionsUseCase_1.GetPromotionsUseCase(this.agent, promotionValidationService_1.promotionValidationService),
                getPromotionBySlug: new GetPromotionBySlugUseCase_1.GetPromotionBySlugUseCase(this.agent, promotionValidationService_1.promotionValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "set", {
        get: function () {
            return {
                getSets: new GetSetsUseCase_1.GetSetsUseCase(this.agent, setValidationService_1.setValidationService),
                getSetBySlug: new GetSetBySlugUseCase_1.GetSetBySlugUseCase(this.agent, setValidationService_1.setValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "brand", {
        get: function () {
            return {
                getBrands: new GetBrandsUseCase_1.GetBrandsUseCase(this.agent, brandValidationService_1.brandValidationService),
                getBrandBySlug: new GetBrandBySlugUseCase_1.GetBrandBySlugUseCase(this.agent, brandValidationService_1.brandValidationService)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "headers", {
        set: function (userHeaders) {
            this.authToken = userHeaders.authToken;
            this.sessionToken = userHeaders.sessionToken;
            this.userLocale = userHeaders.userLocale;
            this.forwardedHost = userHeaders.forwardedHost;
            this.forwardedFor = userHeaders.forwardedFor;
            this.origin = userHeaders.origin;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "setConfigs", {
        set: function (userConfigs) {
            this.cancelToken = userConfigs.cancelToken;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "auth", {
        set: function (tokens) {
            this.authToken = tokens.authToken;
            this.sessionToken = tokens.sessionToken;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ecom.prototype, "locale", {
        set: function (locale) {
            this.userLocale = locale;
            this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
        },
        enumerable: false,
        configurable: true
    });
    Ecom.prototype.setLocale = function (locale) {
        this.userLocale = locale;
        this.agent = this.configureAgent(this.getConfigPropsm(), this.getHeaders());
    };
    Ecom.prototype.getHeaders = function () {
        var headers = {};
        if (this.authToken) {
            headers['Authorization'] = "Bearer ".concat(this.authToken);
        }
        if (this.sessionToken) {
            headers['x-session-token'] = this.sessionToken;
        }
        if (this.userLocale) {
            headers['x-user-locale'] = this.userLocale;
        }
        if (this.forwardedHost) {
            headers['x-forwarded-host'] = this.forwardedHost;
        }
        if (this.forwardedFor) {
            headers['x-forwarded-for'] = this.forwardedFor;
        }
        if (this.origin) {
            headers['origin'] = this.origin;
        }
        return headers;
    };
    Ecom.prototype.getConfigPropsm = function () {
        var config = __assign({}, this.configProps);
        if (this.cancelToken) {
            config['cancelToken'] = this.cancelToken;
        }
        return config;
    };
    Ecom.prototype.configureAgent = function (configProps, headers) {
        return new Agent_1.Agent(configProps.baseUrl, headers, configProps);
    };
    return Ecom;
}());
exports.Ecom = Ecom;
//# sourceMappingURL=Ecom.js.map